import { Card } from 'antd';
import React from 'react';

const RightToInformation = () => {
    return (
        <Card title="माहितीचा अधिकार">
            <h3>माहितीचा अधिकार आधीनियम,२००५ अन्वये माहिती मिळविण्यासाठीच्या अर्जाचा नमुना -</h3>
            <div><a style={{ color: "#0d6efd", fontSize: 16 }} target='_blank' href="https://pskagal.in/api/uploads/rti/arja_namuna_a.pdf">१) अर्ज नमुना अ</a></div>
            <div><a style={{ color: "#0d6efd", fontSize: 16 }} target='_blank' href="https://pskagal.in/api/uploads/rti/arja_namuna_b.pdf">२) अर्ज नमुना ब</a></div>
            <div><a style={{ color: "#0d6efd", fontSize: 16 }} target='_blank' href="https://pskagal.in/api/uploads/rti/arja_namuna_c.pdf">३) अर्ज नमुना क</a></div>
            <h3><a style={{ color: "#0d6efd", fontSize: 16 }} target='_blank' href="https://pskagal.in/api/uploads/rti/1_17_rti.pdf">माहितीचा अधिकार -१ ते १७ बाबी </a> </h3>
            <h3><a style={{ color: "#0d6efd", fontSize: 16 }} target='_blank' href="https://rtionline.maharashtra.gov.in/">महाराष्ट्र राज्य माहिती आयोग -संकेतस्थळ</a> </h3>
            <h3>पंचायत समिती, कागल</h3>
        </Card>
    );
}

export default RightToInformation;